import { FC } from "react";
import { useSelector } from "react-redux";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { ticketDetailedSourcesLabel } from "helpers/tickets";
import { DetailedSource } from "interfaces/entities/ticket";
import { selectAvailableSources } from "store/entities/license";

import { IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

interface IProps {
  filterValues: string[];
  onChange(filterUpdate: IFilterUpdate<DetailedSource[] | null>): void;
}

const items = Object.entries(ticketDetailedSourcesLabel).map(([value, label]) => ({
  key: value,
  name: label,
}));

const TicketSourceFilter: FC<IProps> = props => {
  const { onChange, filterValues } = props;

  const availableSources = useSelector(selectAvailableSources);

  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    const isEmpty = !selectedItem || selectedItem.length === 0;

    onChange({
      name: Filter.DetailedSource,
      value: isEmpty ? null : (selectedItem?.map(item => item.key as DetailedSource) ?? []),
    });
  };

  const availableItems = availableSources
    ? items.filter(item => availableSources?.includes(item.key as DetailedSource))
    : items;

  const selectedSources = items
    .filter(agent => filterValues?.includes(agent.key))
    .map(status => ({ key: status.key, name: status.name }));
  return (
    <Picker
      id="ticket-source-filter"
      type="multi"
      openedOnInit
      hideClearButton
      options={availableItems}
      onSelect={handleChange}
      selected={selectedSources}
      placeholder="Select"
      searchDisabled
    />
  );
};

export default withFilterBase(TicketSourceFilter);
